import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SubscriptionContextValue {
    isSubscriptionModalOpen: boolean;
    openSubscriptionModal: () => void;
    closeSubscriptionModal: () => void;
}

const SubscriptionContext = createContext<SubscriptionContextValue | undefined>(undefined);

export const useSubscription = () => {
    const context = useContext(SubscriptionContext);
    if (!context) {
        throw new Error('useSubscription must be used within a SubscriptionProvider');
    }
    return context;
};

interface SubscriptionProviderProps {
    children: ReactNode;
}

export const SubscriptionProvider: React.FC<SubscriptionProviderProps> = ({ children }) => {
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);

    const openSubscriptionModal = () => {
        setIsSubscriptionModalOpen(true);
    };

    const closeSubscriptionModal = () => {
        setIsSubscriptionModalOpen(false);
    };

    return (
        <SubscriptionContext.Provider
            value={{
                isSubscriptionModalOpen,
                openSubscriptionModal,
                closeSubscriptionModal,
            }}
        >
            {children}
        </SubscriptionContext.Provider>
    );
}; 